<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-04-07 15:37:27
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-07 15:41:41
 -->
<template>
  <div class="devicePic">
    <img src="/static/img/layout/vehicleIdentification.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'devicePic',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .devicePic {
    width: 100%;
    height: 100%;
    img {
      height: 96%;
      margin: 2% 0 0 100px;
    }
  }
</style>
